export const dataVersion = "10.26";
export const ULTRIX_NS_FR1 = {
  model: "ULTRIX-NS-FR1",
  description:
    "Ultrix New Style 1RU Frame w/ 16x16 plus 2 AUX (Ultrimix and Ultriclean included)",
  frameLicenses: [
    {
      item: "ULTRISPEED",
      desc: "Ultrispeed license allows UHD SDI on all I/O",
      qty: 0,
    },
    {
      item: "ULTRISCAPE-CA",
      desc: "Ultriscape license to allow closed caption display support",
      qty: 0,
    },
    {
      item: "ULTRIMIX-MXR",
      desc: "Software enabled 32x16 virtual audio mixer for Ultrix. Up to 4 licenses can provide 128x64 virtual audio mixer.",
      qty: 0,
    },
  ],
  psRedundancy: 0,
  limits: {
    pMax: 119,
    maxVideoIn: 36,
    maxVideoOut: 36,
    maxAudioIn: 768,
    maxAudioOut: 768,
    maxUltriscape: 6,
    maxUltrisync: 36,
    maxUltrisrc: 4,
    maxVideoStream: 0,
    maxAudioStream: 0,
    minVideoIn: 16,
    minVideoOut: 16,
    minAudioIn: 256,
    minAudioOut: 256,
    maxSlots: 2,
    psu: { std: { "ULTRIX-PS": 1 }, redun: { "ULTRIX-PS": 2 } },
  },
  modules: {
    slot1: {
      type: "BLANK",
      model: "ULTRIX-IO-BP",
      description: "Ultrix IO Blank Panel (Cover Plate)",
    },
    slot2: {
      type: "MIOB",
      model: "ULTRIX-MHDB-IO",
      fixed: true,
      ultrisyncLicenses: [],
      ultrisyncUhdLicenses: [],
      ultrisrcLicenses: [],
      ultriscapeLicenses: [],
      defaults: { videoIn: 16, videoOut: 16, audioIn: 256, audioOut: 256 },
      limits: {
        maxVideoIn: 18,
        maxVideoOut: 18,
        maxAudioIn: 384,
        maxAudioOut: 384,
        uscape_ports: [
          ["AUXA", "BNC1"],
          ["BNC5", "BNC7"],
          ["BNC11", "BNC13"],
        ],
        usyncUhd_ports: [
          ["BNC1", "AUXB"],
          ["BNC5", "BNC6"],
          ["BNC11", "BNC12"],
        ],
        licenses: { sync: 18, scape: 3, syncUhd: 3 },
      },
      sfpPorts: {
        AUXA: {},
        AUXB: {},
      },
    },
  },
};
export const ULTRIX_NS_FR2 = {
  model: "ULTRIX-NS-FR2",
  description:
    "Ultrix New Style 2RU Frame w/ 16x16 plus 2 AUX (Ultrimix and Ultriclean included)",
  frameLicenses: [
    {
      item: "ULTRISPEED",
      desc: "Ultrispeed license allows UHD SDI on all I/O",
      qty: 0,
    },
    {
      item: "ULTRISCAPE-CA",
      desc: "Ultriscape license to allow closed caption display support",
      qty: 0,
    },
    {
      item: "ULTRIMIX-MXR",
      desc: "Software enabled 32x16 virtual audio mixer for Ultrix. Up to 4 licenses can provide 128x64 virtual audio mixer.",
      qty: 0,
    },
  ],
  psRedundancy: 0,
  limits: {
    pMax: 133,
    maxVideoIn: 72,
    maxVideoOut: 72,
    maxAudioIn: 1536,
    maxAudioOut: 1536,
    maxUltriscape: 12,
    maxUltrisync: 72,
    maxUltrisrc: 8,
    maxVideoStream: 0,
    maxAudioStream: 0,
    minVideoIn: 16,
    minVideoOut: 16,
    minAudioIn: 256,
    minAudioOut: 256,
    maxSlots: 4,
    psu: { std: { "ULTRIX-PS": 2 }, redun: { "ULTRIX-PS": 4 } },
  },
  modules: {
    slot1: {},
    slot2: {},
    slot3: {},
    slot4: {
      type: "MIOB",
      model: "ULTRIX-MHDB-IO",
      fixed: true,
      ultrisyncLicenses: [],
      ultrisyncUhdLicenses: [],
      ultrisrcLicenses: [],
      ultriscapeLicenses: [],
      defaults: { videoIn: 16, videoOut: 16, audioIn: 256, audioOut: 256 },
      limits: {
        maxVideoIn: 18,
        maxVideoOut: 18,
        maxAudioIn: 384,
        maxAudioOut: 384,
        uscape_ports: [
          ["AUXA", "BNC1"],
          ["BNC5", "BNC7"],
          ["BNC11", "BNC13"],
        ],
        usyncUhd_ports: [
          ["BNC1", "AUXB"],
          ["BNC5", "BNC6"],
          ["BNC11", "BNC12"],
        ],
        licenses: { sync: 18, scape: 3, syncUhd: 3 },
      },
      sfpPorts: {
        AUXA: {},
        AUXB: {},
      },
    },
  },
};
export const ULTRIX_FR5 = {
  model: "ULTRIX-FR5",
  description: "Ultrix 5RU frame",
  frameLicenses: [
    {
      item: "ULTRISPEED-FR5",
      desc: "Ultrispeed license allows UHD SDI on all I/O",
      qty: 0,
    },
    {
      item: "ULTRISCAPE-CA",
      desc: "Ultriscape license to allow closed caption display support",
      qty: 0,
    },
    {
      item: "ULTRIMIX-MXR",
      desc: "Software enabled 32x16 virtual audio mixer for Ultrix. Up to 4 licenses can provide 128x64 virtual audio mixer.",
      qty: 0,
    },
  ],
  psRedundancy: 0,
  limits: {
    pMax: 190, //fans @ 100%
    maxVideoIn: 160,
    maxVideoOut: 160,
    maxAudioIn: 3072,
    maxAudioOut: 3072,
    maxUltriscape: 24,
    maxUltrisync: 160,
    maxUltrisrc: 16,
    maxVideoStream: 0,
    maxAudioStream: 0,
    minVideoIn: 0,
    minVideoOut: 0,
    minAudioIn: 0,
    minAudioOut: 0,
    maxSlots: 9,
    psu: {
      std: { ULTRIPOWER: 1 },
      redun: { ULTRIPOWER: 1, "ULTRIPOWER-PS": 1 },
    },
  },
  modules: {
    macd: {},
    slot0: {},
    slot1: {},
    slot2: {},
    slot3: {},
    slot4: {},
    slot5: {},
    slot6: {},
    slot7: {},
    slot8: {},
  },
};
export const ULTRIX_NS_FR5 = {
  model: "ULTRIX-NS-FR5",
  description: "Ultrix NS 5RU frame",
  frameLicenses: [
    {
      item: "ULTRISPEED-FR5",
      desc: "Ultrispeed license allows UHD SDI on all I/O",
      qty: 0,
    },
    {
      item: "ULTRISCAPE-CA",
      desc: "Ultriscape license to allow closed caption display support",
      qty: 0,
    },
    {
      item: "ULTRIMIX-MXR",
      desc: "Software enabled 32x16 virtual audio mixer for Ultrix. Up to 4 licenses can provide 128x64 virtual audio mixer.",
      qty: 0,
    },
  ],
  psRedundancy: 0,
  limits: {
    pMax: 190, //fans @ 100%
    maxVideoIn: 160,
    maxVideoOut: 160,
    maxAudioIn: 3072,
    maxAudioOut: 3072,
    maxUltriscape: 24,
    maxUltrisync: 160,
    maxUltrisrc: 16,
    maxVideoStream: 0,
    maxAudioStream: 0,
    minVideoIn: 0,
    minVideoOut: 0,
    minAudioIn: 0,
    minAudioOut: 0,
    maxSlots: 9,
    psu: {
      std: { ULTRIPOWER: 1 },
      redun: { ULTRIPOWER: 1, "ULTRIPOWER-PS": 1 },
    },
  },
  modules: {
    macd: {},
    slot0: {},
    slot1: {},
    slot2: {},
    slot3: {},
    slot4: {},
    slot5: {},
    slot6: {},
    slot7: {},
    slot8: {},
  },
};
export const ULTRIX_FR12 = {
  model: "ULTRIX-FR12",
  description: "Ultrix 12RU frame",
  frameLicenses: [
    {
      item: "ULTRISPEED-FR12",
      desc: "Ultrispeed license allows UHD SDI on all I/O",
      qty: 0,
    },
    {
      item: "ULTRISCAPE-CA",
      desc: "Ultriscape license to allow closed caption display support",
      qty: 0,
    },
    {
      item: "ULTRIMIX-MXR",
      desc: "Software enabled 32x16 virtual audio mixer for Ultrix. Up to 4 licenses can provide 128x64 virtual audio mixer.",
      qty: 0,
    },
  ],
  psRedundancy: 0,
  limits: {
    pMax: 807, //fans capped @ 80%
    maxVideoIn: 288,
    maxVideoOut: 288,
    maxAudioIn: 6144,
    maxAudioOut: 6144,
    maxUltriscape: 48,
    maxUltrisync: 288,
    maxUltrisrc: 32,
    maxVideoStream: 0,
    maxAudioStream: 0,
    minVideoIn: 0,
    minVideoOut: 0,
    minAudioIn: 0,
    minAudioOut: 0,
    maxSlots: 16,
    psu: {
      std: { ULTRIPOWER: 2 },
      redun: { ULTRIPOWER: 2, "ULTRIPOWER-PS": 2 },
    },
  },
  modules: {
    macd: {},
    slot1: {},
    slot2: {},
    slot3: {},
    slot4: {},
    slot5: {},
    slot6: {},
    slot7: {},
    slot8: {},
    slot9: {},
    slot10: {},
    slot11: {},
    slot12: {},
    slot13: {},
    slot14: {},
    slot15: {},
    slot16: {},
  },
};

export const BCS = {
  item: "ULTRICORE-BCS",
  desc: "Ultricore HW Controller Platform ",
  id: 0,
  qty: 0,
  licenses: {
    "ULTRICORE-BCS-CLIENT": {
      desc: "Ultricore BCS license to enable an additional 25x client connections (max 150)",
      qty: 0,
    },
    "ULTRICORE-TLX": {
      desc: "Ultricore BCS license to enable tie-line management and switching between router frames",
      qty: 0,
    },
    "ULTRICORE-IP": {
      desc: "Ultricore BCS license to enable IP Control - no video/audio stream licenses included",
      qty: 0,
    },
    "ULTRICORE-IP+V": {
      desc: "Ultricore BCS license to enable IP Control w/support for up to 16 Ross IO video streams",
      qty: 0,
    },
    "ULTRICORE-IP+V3RD": {
      desc: "Ultricore BCS license to enable IP Control w/support for up to 16 3rd party IO video streams",
      qty: 0,
    },
    "ULTRICORE-IP+A": {
      desc: "Ultricore BCS license to enable IP Control w/support for up to 384 Ross IO audio streams",
      qty: 0,
    },
    "ULTRICORE-IP+A3RD": {
      desc: "Ultricore BCS license to enable IP Control w/support for up to 384 3rd party audio I/O streams",
      qty: 0,
    },
    "ULTRICORE-TALLY": {
      desc: "Ultritcore BCS license to enable Tally.",
      qty: 0,
    },
    "ULTRICORE-SNMP": {
      desc: "ULTRICORE-SNMP License",
      qty: 0,
    },
    "ULTRICORE-NVISION": {
      desc: "ULTRICORE-NVISION License",
      qty: 0,
    },
    "ULTRICORE-EMBER+": {
      desc: "Ultricore Ember+ License Option",
      qty: 0,
    },
  },
};
export const ACUFR_CPU = {
  model: "ACUFR-CPU",
  type: "ACUFR-CPU",
  description: "Acuity FR Series Frame CPU",
  id: 0,
  qty: 0,
  licenses: {
    "ACUFR-AUDMIXSM": {
      item: "ACUFR-AUDMIXSM",
      desc: "Small Audio Mixer Interface (16 and Fewer Inputs)",
      qty: 0,
    },
    "ACUFR-AUDMIXLG": {
      item: "ACUFR-AUDMIXLG",
      desc: "Large Audio Mixer Interface (More than 16 Inputs)",
      qty: 0,
    },
    "ACUFR-AUDMIXLG-ROSS": {
      item: "ACUFR-AUDMIXLG-ROSS",
      desc: "Large Audio Mixer Interface (More than 16 Inputs - ROSS)",
      qty: 0,
    },
    "ACUFR-CGCII": {
      item: "ACUFR-CGCII",
      desc: "Character Generator Interface",
      qty: 0,
    },
    "ACUFR-CGCII-ROSS": {
      item: "ACUFR-CGCII-ROSS",
      desc: "Character Generator Interface - ROSS",
      qty: 0,
    },
    "ACUFR-ROBOCAM": {
      item: "ACUFR-ROBOCAM",
      desc: "Robotic Camera System Interface",
      qty: 0,
    },
    "ACUFR-ROBOCAM-ROSS": {
      item: "ACUFR-ROBOCAM-ROSS",
      desc: "Robotic Camera System Interface - ROSS",
      qty: 0,
    },
    "ACUFR-ROUTER": {
      item: "ACUFR-ROUTER",
      desc: "Routing Switcher Interface",
      qty: 0,
    },
    "ACUFR-ROUTER-ROSS": {
      item: "ACUFR-ROUTER-ROSS",
      desc: "Routing Switcher Interface - ROSS",
      qty: 0,
    },
    "ACUFR-SDxE-3DWARP-LIC": {
      item: "ACUFR-SDxE-3DWARP-LIC",
      desc: "Acuity SDxE 3D DVE with WARP license",
      qty: 0,
    },
  },
  limits: { pMax: 35 },
};
export const CHMFR5_CPU = {
  model: "CHMFR5-CPU",
  type: "CHMFR5-CPU",
  description: "Carbonite HyperMax FR Series Frame CPU",
  id: 0,
  qty: 0,
  licenses: {},
  limits: { pMax: 35 },
};
export const ACUFR5NS_CPU = {
  model: "ACUFR5NS-CPU",
  type: "ACUFR5NS-CPU",
  description: "Acuity FR5-NS Series Frame CPU",
  id: 0,
  qty: 0,
  licenses: {
    "ACUFR-AUDMIXSM": {
      item: "ACUFR-AUDMIXSM",
      desc: "Small Audio Mixer Interface (16 and Fewer Inputs)",
      qty: 0,
    },
    "ACUFR-AUDMIXLG": {
      item: "ACUFR-AUDMIXLG",
      desc: "Large Audio Mixer Interface (More than 16 Inputs)",
      qty: 0,
    },
    "ACUFR-AUDMIXLG-ROSS": {
      item: "ACUFR-AUDMIXLG-ROSS",
      desc: "Large Audio Mixer Interface (More than 16 Inputs - ROSS)",
      qty: 0,
    },
    "ACUFR-CGCII": {
      item: "ACUFR-CGCII",
      desc: "Character Generator Interface",
      qty: 0,
    },
    "ACUFR-CGCII-ROSS": {
      item: "ACUFR-CGCII-ROSS",
      desc: "Character Generator Interface - ROSS",
      qty: 0,
    },
    "ACUFR-ROBOCAM": {
      item: "ACUFR-ROBOCAM",
      desc: "Robotic Camera System Interface",
      qty: 0,
    },
    "ACUFR-ROBOCAM-ROSS": {
      item: "ACUFR-ROBOCAM-ROSS",
      desc: "Robotic Camera System Interface - ROSS",
      qty: 0,
    },
    "ACUFR-ROUTER": {
      item: "ACUFR-ROUTER",
      desc: "Routing Switcher Interface",
      qty: 0,
    },
    "ACUFR-ROUTER-ROSS": {
      item: "ACUFR-ROUTER-ROSS",
      desc: "Routing Switcher Interface - ROSS",
      qty: 0,
    },
    "ACUFR-SDxE-3DWARP-LIC": {
      item: "ACUFR-SDxE-3DWARP-LIC",
      desc: "Acuity SDxE 3D DVE with WARP license",
      qty: 0,
    },
  },
  limits: { pMax: 35 },
};
export const CHMFR5NS_CPU = {
  model: "CHMFR5NS-CPU",
  type: "CHMFR5NS-CPU",
  description: "Carbonite HyperMax FR5-NS Series Frame CPU",
  id: 0,
  qty: 0,
  licenses: {},
  limits: { pMax: 35 },
};
export const ACUFR12_CPU = {
  model: "ACUFR12-CPU",
  type: "ACUFR12-CPU",
  description: "Acuity FR12 Series Frame CPU",
  id: 0,
  qty: 0,
  licenses: {
    "ACUFR-AUDMIXSM": {
      item: "ACUFR-AUDMIXSM",
      desc: "Small Audio Mixer Interface (16 and Fewer Inputs)",
      qty: 0,
    },
    "ACUFR-AUDMIXLG": {
      item: "ACUFR-AUDMIXLG",
      desc: "Large Audio Mixer Interface (More than 16 Inputs)",
      qty: 0,
    },
    "ACUFR-AUDMIXLG-ROSS": {
      item: "ACUFR-AUDMIXLG-ROSS",
      desc: "Large Audio Mixer Interface (More than 16 Inputs - ROSS)",
      qty: 0,
    },
    "ACUFR-CGCII": {
      item: "ACUFR-CGCII",
      desc: "Character Generator Interface",
      qty: 0,
    },
    "ACUFR-CGCII-ROSS": {
      item: "ACUFR-CGCII-ROSS",
      desc: "Character Generator Interface - ROSS",
      qty: 0,
    },
    "ACUFR-ROBOCAM": {
      item: "ACUFR-ROBOCAM",
      desc: "Robotic Camera System Interface",
      qty: 0,
    },
    "ACUFR-ROBOCAM-ROSS": {
      item: "ACUFR-ROBOCAM-ROSS",
      desc: "Robotic Camera System Interface - ROSS",
      qty: 0,
    },
    "ACUFR-ROUTER": {
      item: "ACUFR-ROUTER",
      desc: "Routing Switcher Interface",
      qty: 0,
    },
    "ACUFR-ROUTER-ROSS": {
      item: "ACUFR-ROUTER-ROSS",
      desc: "Routing Switcher Interface - ROSS",
      qty: 0,
    },
    "ACUFR-SDxE-3DWARP-LIC": {
      item: "ACUFR-SDxE-3DWARP-LIC",
      desc: "Acuity SDxE 3D DVE with WARP license",
      qty: 0,
    },
  },
  limits: { pMax: 35 },
};
export const CHMFR12_CPU = {
  model: "CHMFR12-CPU",
  type: "CHMFR12-CPU",
  description: "Carbonite HyperMax FR12 Series Frame CPU",
  id: 0,
  qty: 0,
  licenses: {},
  limits: { pMax: 35 },
};
export const ioModules = Object.freeze([
  {
    type: "BLANK",
    model: "ULTRIX-IO-BP",
    description: "Ultrix IO Blank Panel (Cover Plate)",
  },
  {
    type: "BLANK-IO-BAF",
    model: "ULTRIX-IO-BAF",
    description: "Blanking plate baffle - Standard IO slot",
  },

  {
    type: "BLANK-MACD-BAF",
    model: "ULTRIX-MACD-BAF",
    description: "Blanking plate baffle - MACD slot",
  },

  {
    type: "HDBNC",
    model: "ULTRIX-HDB-IO-A",
    description: "I/O Board - 16x16 HD-BNC, Advanced Connectivity, 2 AUX IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 16, videoOut: 16, audioIn: 256, audioOut: 256 },
    limits: {
      pMax: 60,
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [
        ["AUXA", "BNC1"],
        ["BNC5", "BNC7"],
        ["BNC11", "BNC13"],
      ],
      usyncUhd_ports: [
        ["BNC1", "AUXB"],
        ["BNC5", "BNC6"],
        ["BNC11", "BNC12"],
      ],
      licenses: { sync: 18, scape: 3, syncUhd: 3 },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
    },
    obsolete: true,
    substitute: "ULTRIX-HDX-IO",
  },
  {
    type: "HDXIO",
    model: "ULTRIX-HDX-IO",
    description:
      "I/O Board - 2nd.Gen. 16x16 HD-BNC, Advanced Connectivity, 4 AUX IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    licenses: {
      ultriprocHDR: {
        item: "ULTRIPROC",
        desc: "Procamp, color correction and SDR/HDR conversion license.",
        ioRate: "hd",
        ioType: "outputs",
        positions: [],
      },
      ultriproc3D: {
        item: "ULTRIPROC-3DLUT",
        desc: "Procamp, color correction and SDR/HDR conversion with 3D LUT license.",
        ioRate: "hd",
        ioType: "outputs",
        positions: [],
      },
      ultristreamOut: {
        item: "ULTRISTREAM",
        desc: "Ultriscape MultiViewer NDI streaming license for Ultrix 'X' series cards.",
        positions: [],
      },
      ultrimixDante: {
        item: "ULTRIMIX-DANTE",
        desc: "Dante 64 ch. I/O license for Ultrix 'X' series cards.",
        positions: [],
      },
    },
    defaults: { videoIn: 16, videoOut: 16, audioIn: 256, audioOut: 256 },
    limits: {
      pMax: 92,
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [["AUXA", "BNC1"], ["AUXB", "BNC5"], ["BNC13"]],
      usyncUhd_ports: [
        ["BNC1", "AUXA"],
        ["BNC2"],
        ["BNC3"],
        ["BNC4"],
        ["BNC5", "AUXB"],
        ["BNC6"],
        ["BNC7"],
        ["BNC8"],
        ["BNC9"],
        ["BNC10"],
        ["BNC11"],
        ["BNC12"],
        ["BNC13"],
        ["BNC14"],
        ["BNC15"],
        ["BNC16"],
      ],
      uproc_ports: [
        "BNC2",
        "BNC4",
        "BNC6",
        "BNC8",
        "BNC10",
        "BNC12",
        "BNC14",
        "BNC16",
      ],
      uprocUhd_ports: ["BNC2", "BNC6", "BNC10", "BNC14"],
      licenses: {
        sync: 18,
        scape: 3,
        syncUhd: 16,
        proc: 8,
        procUhd: 4,
        streamOut: 1,
        uDante: 1,
      },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
      AUXC: {},
      AUXD: {},
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "MIOB",
    model: "ULTRIX-MHDB-IO",
    fixed: true,
    description: "Main I/O Board - 16x16, Advanced Connectivity, 2 AUX IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 16, videoOut: 16, audioIn: 256, audioOut: 256 },
    limits: {
      pMax: 0, //inc w frame
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [
        ["AUXA", "BNC1"],
        ["BNC5", "BNC7"],
        ["BNC11", "BNC13"],
      ],
      usyncUhd_ports: [
        ["BNC1", "AUXB"],
        ["BNC5", "BNC6"],
        ["BNC11", "BNC12"],
      ],
      licenses: { sync: 18, scape: 3, syncUhd: 3 },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFPIO",
    model: "ULTRIX-SFP-IO",
    description:
      "I/O Board - 16x16 using 16 SFP cages, Advanced Connectivity, 2 AUX IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 73,
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [
        ["AUXA", "port1"],
        ["port5", "port7"],
        ["port11", "port13"],
      ],
      usyncUhd_ports: [
        ["port1", "AUXB"],
        ["port5", "port6"],
        ["port11", "port12"],
      ],
      licenses: { sync: 18, scape: 3, syncUhd: 3 },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
      port1: {},
      port2: {},
      port3: {},
      port4: {},
      port5: {},
      port6: {},
      port7: {},
      port8: {},
      port9: {},
      port10: {},
      port11: {},
      port12: {},
      port13: {},
      port14: {},
      port15: {},
      port16: {},
    },
    obsolete: true,
    substitute: "ULTRIX-MODX-IO",
  },
  {
    type: "MODXIO",
    model: "ULTRIX-MODX-IO",
    description: "Modular I/O Board for ULTRIX-MOD sub-modules.",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    licenses: {
      ultriprocHDR: {
        item: "ULTRIPROC",
        desc: "Procamp, color correction and SDR/HDR conversion license",
        ioRate: "hd",
        ioType: "outputs",
        positions: [],
      },
      ultriproc3D: {
        item: "ULTRIPROC-3DLUT",
        desc: "Procamp, color correction and SDR/HDR conversion with 3D LUT license",
        ioRate: "hd",
        ioType: "outputs",
        positions: [],
      },
      ultristreamOut: {
        item: "ULTRISTREAM",
        desc: "Ultriscape MultiViewer NDI streaming license for Ultrix 'X' series cards.",
        positions: [],
      },
      ultrimixDante: {
        item: "ULTRIMIX-DANTE",
        desc: "Dante 64 ch. I/O license for Ultrix 'X' series cards.",
        positions: [],
      },
    },

    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 92,
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [
        ["AUXA", "slotA.port1"],
        ["AUXB", "slotB.port1"],
        ["slotD.port1"],
      ],
      usyncUhd_ports: [
        ["slotA.port1", "AUXA"],
        ["slotA.port2"],
        ["slotA.port3"],
        ["slotA.port4"],
        ["slotB.port1", "AUXB"],
        ["slotB.port2"],
        ["slotB.port3"],
        ["slotB.port4"],
        ["slotC.port1"],
        ["slotC.port2"],
        ["slotC.port3"],
        ["slotC.port4"],
        ["slotD.port1"],
        ["slotD.port2"],
        ["slotD.port3"],
        ["slotD.port4"],
      ],
      uproc_ports: [
        "slotA.port2",
        "slotA.port4",
        "slotB.port2",
        "slotB.port4",
        "slotC.port2",
        "slotC.port4",
        "slotD.port2",
        "slotD.port4",
      ],
      uprocUhd_ports: [
        "slotA.port2",
        "slotB.port2",
        "slotC.port2",
        "slotD.port2",
      ],
      licenses: {
        sync: 18,
        scape: 3,
        syncUhd: 16,
        proc: 8,
        procUhd: 4,
        streamOut: 1,
        uDante: 1,
      },
    },
    modules: {
      slotA: {
        type: "BLANK",
        model: "ULTRIX-MOD-BP",
        description: "Blank cover plate for unpopulated ULTRIX-MODX-IO slot.",
      },
      slotB: {
        type: "BLANK",
        model: "ULTRIX-MOD-BP",
        description: "Blank cover plate for unpopulated ULTRIX-MODX-IO slot.",
      },
      slotC: {
        type: "BLANK",
        model: "ULTRIX-MOD-BP",
        description: "Blank cover plate for unpopulated ULTRIX-MODX-IO slot.",
      },
      slotD: {
        type: "BLANK",
        model: "ULTRIX-MOD-BP",
        description: "Blank cover plate for unpopulated ULTRIX-MODX-IO slot.",
      },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
      AUXC: {},
      AUXD: {},
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "IPXIO",
    model: "ULTRIX-IPX-IO",
    description: "IP I/O Board - (4x) 100GbE ports. Includes 4 AUX Ports.",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: {
      videoIn: 16,
      videoOut: 16,
      audioIn: 256,
      audioOut: 256,
    },
    limits: {
      pMax: 125,
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [["AUXA", "Out1"], ["AUXB", "Out5"], ["Out13"]],
      licenses: { scape: 3 },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
      AUXC: {},
      AUXD: {},
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "IPIO",
    model: "ULTRIX-IP-IO",
    description:
      "IP I/O Board - (4x) 25GbE, Advanced Connectivity, 2 AUX IO for MV",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 16, videoOut: 16, audioIn: 256, audioOut: 256 },
    limits: {
      pMax: 85,
      maxVideoIn: 18,
      maxVideoOut: 18,
      maxAudioIn: 384,
      maxAudioOut: 384,
      uscape_ports: [
        ["AUXA", "Out1"],
        ["AUXB", "Out9"],
      ],
      licenses: { scape: 2 },
    },
    sfpPorts: {
      AUXA: {},
      AUXB: {},
    },
    obsolete: true,
    substitute: "ULTRIX-IPX-IO",
  },

  {
    type: "Acuity",
    model: "SWR-SDPE",
    description: "Software Defined Production Engine",
    licenses: {
      "HD-ME": {
        item: "ACUFR-HD-ME",
        desc: "Acuity HD ME license",
        qty: 1,
      },
      "UHD-ME": {
        item: "ACUFR-UHD-ME",
        desc: "Acuity UHD ME license",
        qty: 0,
      },
      "ACUFR-3DDVE-LIC": {
        item: "ACUFR-3DDVE-LIC",
        qty: 0,
        desc: "Acuity 3D DVE license",
      },
    },
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: { pMax: 120, positions: { FR5: [8, 7, 6, 5], FR2: [], FR1: [] } },
    sfpPorts: {},
    obsolete: false,
    substitute: "",
  },
  {
    type: "SWR-SDxE (Acuity)",
    model: "SWR-SDXE",
    description: "Software Defined xRossCompute Engine",
    licenses: {},
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 200,
      positions: { FR12: [8], FR5: [1], FR2: [], FR1: [] },
      moduleHeight: 2,
    },
    sfpPorts: {},
    obsolete: false,
    substitute: "",
  },
  {
    type: "Carbonite",
    model: "SWR-SDPE",
    description: "Software Defined Production Engine",
    licenses: {
      ME1: { item: "CUFR-ADD-ME1", desc: "License to enable ME #1", qty: 1 },
      ME2: { item: "CUFR-ADD-ME2", desc: "License to enable ME #2", qty: 0 },
      UHD: {
        item: "CUFR-ADD-UHD",
        desc: "License to enable UHD video format",
        qty: 0,
      },
      FSFC: {
        item: "CUFR-ADD-FSFC",
        desc: "License to enable Frame Sync and Format Conversion",
        qty: 0,
      },
      PACC: {
        item: "CUFR-ADD-PACC",
        desc: "License to enable Proc Amp and Colour Correction",
        qty: 0,
      },
      MOSAIC: {
        item: "CUFR-ADD-MOSAIC",
        desc: "License to enable Carbonite Mosaic",
        qty: 0,
      },
    },
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 120,
      positions: { FR5: [8, 7, 6, 5], FR2: [1, 3], FR1: [] },
    },
    sfpPorts: {},
    obsolete: false,
    substitute: "",
  },

  {
    type: "HyperMax",
    model: "SWR-SDPE",
    description: "Software Defined Production Engine",
    licenses: {
      MaxME: {
        item: "CHMFR-ADD-MAXLIC",
        desc: "Carbonite HyperMax MaxLic license",
        qty: 1,
      },
    },
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: { pMax: 120, positions: { FR5: [8, 7, 6, 5], FR2: [], FR1: [] } },
    sfpPorts: {},
    obsolete: false,
    substitute: "",
  },
]);
export const modularIOModules = Object.freeze([
  {
    type: "BLANK",
    model: "ULTRIX-MOD-BP",
    description: "Blank cover plate for unpopulated ULTRIX-MODX-IO slot.",
    obsolete: false,
    substitute: "",
  },
  {
    type: "MODXSFP",
    model: "ULTRIX-MOD-SFP",
    description: "SFP IO sub-module for ULTRIX-MODX-IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 4,
      maxVideoIn: 4,
      maxVideoOut: 4,
      maxAudioIn: 64,
      maxAudioOut: 64,
      uscape_ports: [],
      usyncUhd_ports: [],
      licenses: { sync: 4, scape: 1, syncUhd: 4, proc: 2, procUhd: 1 },
    },
    sfpPorts: {
      port1: {},
      port2: {},
      port3: {},
      port4: {},
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "MODXSDI",
    model: "ULTRIX-MOD-SDI",
    description: "HDBNC/SDI IO sub-module for ULTRIX-MODX-IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 4, videoOut: 4, audioIn: 64, audioOut: 64 },
    limits: {
      pMax: 5,
      maxVideoIn: 4,
      maxVideoOut: 4,
      maxAudioIn: 64,
      maxAudioOut: 64,
      uscape_ports: [],
      usyncUhd_ports: [],
      licenses: { sync: 4, scape: 1, syncUhd: 4, proc: 2, procUhd: 1 },
    },

    obsolete: false,
    substitute: "",
  },
  {
    type: "MODXNDI",
    model: "ULTRIX-MOD-NDI",
    description: "NDI sub-module for ULTRIX-MODX-IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 5,
      maxVideoIn: 4,
      maxVideoOut: 4,
      maxAudioIn: 64,
      maxAudioOut: 64,
      uscape_ports: [],
      usyncUhd_ports: [],
      licenses: { sync: 4, scape: 1, syncUhd: 4, proc: 2, procUhd: 1 },
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "MODXDPT",
    model: "ULTRIX-MOD-DPT",
    description: "DisplayPort output sub-module for ULTRIX-MODX-IO",
    ultrisyncLicenses: [],
    ultrisyncUhdLicenses: [],
    ultrisrcLicenses: [],
    ultriscapeLicenses: [],
    defaults: { videoIn: 0, videoOut: 0, audioIn: 0, audioOut: 0 },
    limits: {
      pMax: 12,
      maxVideoIn: 0,
      maxVideoOut: 4,
      maxAudioIn: 0,
      maxAudioOut: 0,
      uscape_ports: [],
      usyncUhd_ports: [],
      licenses: { sync: 0, scape: 1, syncUhd: 0, proc: 2, procUhd: 1 },
    },
    obsolete: false,
    substitute: "",
  },
]);
export const SFP = Object.freeze([
  {
    type: "SFP-HDB-IO-3G",
    model: "SFP-HDB-IO-3G",
    description:
      "3G-SDI HD-BNC Transceiver.  Provides 1 SDI input and 1 SDI output.",
    group: "SDI",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: { ultrisync: 1, ultriscape: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-HDB-IO-12G",
    model: "SFP-HDB-IO-12G",
    description:
      "12G SDI HD-BNC Transceiver.  Provides 1 SDI input and 1 SDI output.",
    group: "SDI",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultrisync: 1,
      ultriscape: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-HDB-IN-12G",
    model: "SFP-HDB-IN-12G",
    description:
      "12G SDI HD-BNC Dual Receiver.  Provides 1 SDI input.  Lose output of the aux I/O port with this SFP",
    group: "SDI",
    videoIn: 1,
    videoOut: 0,
    audioIn: 16,
    audioOut: 0,
    licenseApplicable: { ultrispeed: 1, ultrisync: 1, ultrisyncuhd: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-HDB-OUT-12G",
    model: "SFP-HDB-OUT-12G",
    description:
      "12G SDI HD-BNC Dual Transmitter.  Provides 1 SDI output.  Lose input of the aux I/O port with this SFP.",
    group: "SDI",
    videoIn: 0,
    videoOut: 1,
    audioIn: 0,
    audioOut: 16,
    licenseApplicable: { ultrispeed: 1, ultriscape: 1 },
    obsolete: true,
    substitute: "",
  },
  {
    type: "SFP-HDM-IN-12G",
    model: "SFP-HDM-IN-12G",
    description:
      "HDMI 2.0 to SDI Receiver.  Lose output of the aux I/O port with this SFP.",
    group: "HDMI",
    videoIn: 1,
    videoOut: 0,
    audioIn: 8,
    audioOut: 0,
    licenseApplicable: { ultrispeed: 1, ultrisync: 1, ultrisyncuhd: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-HDMI-IN",
    model: "SFP-HDM-IN",
    description:
      "HDMI/DVI to SDI Receiver.  Lose output of the aux I/O port with this SFP.",
    group: "HDMI",
    videoIn: 1,
    videoOut: 0,
    audioIn: 8,
    audioOut: 0,
    licenseApplicable: { ultrisync: 1 },
    obsolete: true,
    substitute: "SFP-HDMI-IN-12G",
  },
  {
    type: "SFP-HDMI-OUT",
    model: "SFP-HDM-OUT",
    description:
      "SDI to HDMI/DVI Transmitter.  Lose input of the I/O port with this SFP.",
    group: "HDMI",
    videoIn: 0,
    videoOut: 1,
    audioIn: 0,
    audioOut: 8,
    licenseApplicable: { ultriscape: 1 },
    obsolete: true,
    substitute: "SFP-HDMI-OUT-12G",
  },
  {
    type: "SFP-HDM-OUT-12G",
    model: "SFP-HDM-OUT-12G",
    description:
      "12G SDI to HDMI 2.0 Transmitter.  Lose input of the I/O port with this SFP.",
    group: "HDMI",
    videoIn: 0,
    videoOut: 1,
    audioIn: 0,
    audioOut: 8,
    licenseApplicable: { ultriscape: 1, ultrispeed: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-3G",
    model: "SFP-FIBER-3G",
    description:
      "3G-SDI Optical Transceiver, 1310nm. Provides 1 optical input and 1 optical output.",
    group: "SDI",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: { ultrisync: 1, ultriscape: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G",
    model: "SFP-FIBER-12G",
    description:
      "12G SDI Optical transceiver, 1310nm. Provides 1 optical input and 1 optical output.",
    group: "SDI",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-MADI-850MM",
    model: "SFP-MADI-850MM",
    description:
      "MADI 850nm MultiMode Fiber Transceiver.  Provides a MADI link with up to 64 channels in and out.",
    group: "MADI",
    videoIn: 0,
    videoOut: 0,
    audioIn: 64,
    audioOut: 64,
    licenseApplicable: { ultrisrc: 1 },
    obsolete: true,
    substitute: "",
  },
  {
    type: "SFP-MADI-1310SM",
    model: "SFP-MADI-1310SM",
    description:
      "MADI 1310nm SingleMode Fiber Transceiver.  Provides a MADI link with up to 64 channels in and out.",
    group: "MADI",
    videoIn: 0,
    videoOut: 0,
    audioIn: 64,
    audioOut: 64,
    licenseApplicable: { ultrisrc: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-MADI-1300MM",
    model: "SFP-MADI-1300MM",
    description:
      "Fiber 1300nm Multi Mode MADI transceiver SFP. Provides a MADI link with up to 64 channels in and out",
    group: "MADI",
    videoIn: 0,
    videoOut: 0,
    audioIn: 64,
    audioOut: 64,
    licenseApplicable: { ultrisrc: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-MADI-COAX",
    model: "SFP-MADI-COAX",
    description:
      "MADI Coax Transceiver.  Provides a MADI link with up to 64 channels in and out.",
    group: "MADI",
    videoIn: 0,
    videoOut: 0,
    audioIn: 64,
    audioOut: 64,
    licenseApplicable: { ultrisrc: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-RJ45-1G",
    model: "SFP-RJ45-1G",
    description: "1G Copper/RJ45 GbE SFP.",
    group: "Ethernet",
    videoIn: 0,
    videoOut: 0,
    audioIn: 0,
    audioOut: 0,
    licenseApplicable: { ultristreamOut: 1, ultrimixDante: 1 },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1270nm",
    model: "SFP-FIBER-12G-27",
    description: "SFP Tx/Rx, 12G, CWDM, 1270nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1290nm",
    model: "SFP-FIBER-12G-29",
    description: "SFP Tx/Rx, 12G, CWDM, 1290nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1310nm",
    model: "SFP-FIBER-12G-31",
    description: "SFP Tx/Rx, 12G, CWDM, 1310nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1330nm",
    model: "SFP-FIBER-12G-33",
    description: "SFP Tx/Rx, 12G, CWDM, 1330nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1350nm",
    model: "SFP-FIBER-12G-35",
    description: "SFP Tx/Rx, 12G, CWDM, 1350nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1370nm",
    model: "SFP-FIBER-12G-37",
    description: "SFP Tx/Rx, 12G, CWDM, 1370nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1430nm",
    model: "SFP-FIBER-12G-43",
    description: "SFP Tx/Rx, 12G, CWDM, 1430nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1450nm",
    model: "SFP-FIBER-12G-45",
    description: "SFP Tx/Rx, 12G, CWDM, 1450nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1470nm",
    model: "SFP-FIBER-12G-47",
    description: "SFP Tx/Rx, 12G, CWDM, 1470nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1490nm",
    model: "SFP-FIBER-12G-49",
    description: "SFP Tx/Rx, 12G, CWDM, 1490nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1510nm",
    model: "SFP-FIBER-12G-51",
    description: "SFP Tx/Rx, 12G, CWDM, 1510nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1530nm",
    model: "SFP-FIBER-12G-53",
    description: "SFP Tx/Rx, 12G, CWDM, 1530nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1550nm",
    model: "SFP-FIBER-12G-55",
    description: "SFP Tx/Rx, 12G, CWDM, 1550nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1570nm",
    model: "SFP-FIBER-12G-57",
    description: "SFP Tx/Rx, 12G, CWDM, 1570nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1590nm",
    model: "SFP-FIBER-12G-59",
    description: "SFP Tx/Rx, 12G, CWDM, 1590nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
  {
    type: "SFP-FIBER-12G-1610nm",
    model: "SFP-FIBER-12G-61",
    description: "SFP Tx/Rx, 12G, CWDM, 1610nm, standard sensitivity receiver",
    group: "SDI: CWDM FIBER",
    videoIn: 1,
    videoOut: 1,
    audioIn: 16,
    audioOut: 16,
    licenseApplicable: {
      ultrispeed: 1,
      ultriscape: 1,
      ultrisync: 1,
      ultrisyncuhd: 1,
    },
    obsolete: false,
    substitute: "",
  },
]);
/***
 * array order = render order
 * parts object
 * {
 *    item: item displayname,
 *    desc: description,
 *    qty: quantity,
 *    subtext: optional second line description,
 *    max: optional maximum qty, if 1 then renders as checkbox
 *    fsmatch: opional frame size match to display object in form. [1]==> framesize=1, [1,2] ==> framesize = 1 OR 2
 *       TODO: move to use JSONlogic (if required)
 * pop: option popper object
 * {
 *      popTitle: optional popper title
 *      popImg: optional popper image URL
 *        {src: local source URL
 *         alt: alt text}
 *      popContent: popper content
 * }
 * }
 *
 *****/
export const frameParts = [
  {
    item: "ULTRIX-PS",
    desc: "Ultrix Power Supply",
    qty: 0,
    min: 0,
    fsmatch: [1, 2],
    subtext: "1 and 2RU Ultrix frames only",
  },
  {
    item: "ULTRIX-FM-NS-1RU",
    desc: "Fan replacement kit for 1RU frame",
    qty: 0,
    fsmatch: [1],
    pop: {
      popTitle: "Ultrix FR1 fan module (1 per)",
      popImg: {
        src: "../assets/images/FR1_fan.webp",
        alt: "FR1 fan module",
      },
    },
  },
  {
    item: "ULTRIX-FM-NS-2RU",
    desc: "Fan replacement kit for 2RU frame",
    qty: 0,
    max: 10,
    fsmatch: [2],
    pop: {
      popTitle: "Ultrix FR2 fan module (1 per)",
      popImg: {
        src: "../assets/images/FR2_fan.webp",
        alt: "FR2 fan module",
      },
    },
  },
  {
    item: "ULTRIX-FM-5RU",
    desc: "Fan replacement module for 5RU frame",
    qty: 0,
    fsmatch: [5],
    pop: {
      popTitle: "Ultrix FR5 fan module (5 per)",
      popImg: {
        src: "../assets/images/FR5_fan.webp",
        alt: "FR5 fan module",
      },
    },
  },
  {
    item: "ULTRIX-FR12-XPT",
    desc: "Optional Spare Crosspoint for Ultrix-FR12",
    qty: 0,
    max: 2,
    fsmatch: [12],
  },
  {
    item: "ULTRIX-FR12-IOFAN",
    desc: "Optional Spare IO Fan Module for Ultrix-FR12",
    qty: 0,
    max: 8,
    pop: {
      popTitle: "Ultrix FR12 IO Fan (10 per)",
      popImg: {
        src: "../assets/images/FR12_IO_fan.webp",
        alt: "FR12-IOFAN image",
      },
    },
    fsmatch: [12],
  },
  {
    item: "ULTRIX-FR12-FCBFAN", //2101AR-626
    desc: "Optional Spare Crosspoint Fan Module for Ultrix-FR12",
    qty: 0,
    max: 8,
    pop: {
      popTitle: "Ultrix FR12 FCB fan (5 per)",
      popImg: {
        src: "../assets/images/FR12_FCB_fan.webp",
        alt: "FR12-FCBFAN image",
      },
    },
    fsmatch: [12],
  },
  /* {
    item: "ULTRIX-FR12-EXFAN", //2101AR-676
    desc: "Optional Spare Exhaust Fan Module for Ultrix-FR12",
    qty: 0,
    max: 2,
    pop: {
      popTitle: "Ultrix Exhaust Fan (1 per)",
      popImg: {
        src: "../assets/images/FR12_EXFAN.webp",
        alt: "FR12-EXFAN image",
      },
    },
    fsmatch: [12],
  }, */
  {
    item: "ULTRIX-FR12-FC",
    desc: "Optional Spare Frame Control Module for Ultrix-FR12",
    qty: 0,
    max: 4,
    fsmatch: [12],
  },
  {
    item: "ULTRIX-FR12-DCPWR",
    desc: "Optional Spare DC Power Module for Ultrix-FR12",
    qty: 0,
    max: 4,
    fsmatch: [12],
  },
  {
    item: "ULTRIX-FR12-REF",
    desc: "Optional Spare Reference Module for Ultrix-FR12",
    qty: 0,
    max: 4,
    fsmatch: [12],
  },
  {
    item: "ULTRIX-FAN",
    desc: "Single replacement fan",
    qty: 0,
    subtext: "40x40x28mm fan",
    fsmatch: [1, 2, 5],
  },

  {
    item: "ULTRIPOWER",
    desc: "Ultrix Rackmount 1RU power supply frame with 1 power supply loaded.",
    qty: 0,
    min: 0,
    pop: {
      popTitle: "ULTRIPOWER",
      popImg: {
        src: "../assets/images/UPwr_w300.png",
        alt: "ULTRIPOWER image",
      },
    },
  },
  {
    item: "ULTRIPOWER-PS",
    desc: "Additional modular power supply for Ultripower rack mount frame.",
    qty: 0,
    min: 0,
  },
  {
    item: "ULTRICOOL",
    desc: "Smart directional 1RU cooling system with automatic bonded mode, Dashboard or manual override",
    qty: 0,
  },
  {
    item: "ULTRICOOL-PS",
    desc: "Redundant power supply for Ultricool",
    qty: 0,
  },
  {
    item: "DETOUR",
    desc: "Standalone, 12Gbps SDI bypass relay with integrated 1x4 DA",
    qty: 0,
  },
  {
    item: "ULTRIX-UCCI",
    desc: "Secondary Internal Ultricore Controller",
    qty: 0,
    pMax: 5,
    max: 1,
    fsmatch: [5],
  },
  {
    type: "BLANK-UCCI-BAF",
    item: "ULTRIX-UCCI-BAF",
    desc: "Blanking plate baffle - UCCI slot",
    qty: 0,
  },
];
export const controlParts = Object.freeze([
  {
    item: "ULTRICORE-BCS-PS",
    desc: "Redundant power supply for ULTRICORE-BCS ",
    qty: 0,
    max: 50,
  },
  {
    item: "ULTRITOUCH2",
    desc: "Ethernet Enabled 2RU LCD Touchscreen Control Panel",
    qty: 0,
    max: 50,
    pop: {
      popTitle: "Ultritouch 2",
      popImg: {
        src: "../assets/images/ultritouch_tiny_02.png",
        alt: "Ultritouch RCP image",
      },
      popContent:
        "The panel is a shallow 2RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™",
    },
    obsolete: true,
    substitute: "ULTRITOUCH-2-HR",
  },
  {
    item: "ULTRITOUCH-2-HR",
    desc: "Ethernet Enabled 2RU Hi Res LCD Touchscreen Control Panel",
    qty: 0,
    max: 50,
    pop: {
      popTitle: "Ultritouch 2 HR",
      popImg: {
        src: "../assets/images/ultritouch_tiny_02.png",
        alt: "Ultritouch RCP image",
      },
      popContent:
        "The panel is a shallow 2RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™",
    },
  },
  {
    item: "ULTRITOUCH4",
    desc: "Ethernet Enabled 4RU LCD Touchscreen Control Panel",
    qty: 0,
    max: 50,
    pop: {
      popTitle: "Ultritouch 4",
      popImg: {
        src: "../assets/images/ultritouch4_tiny.png",
        alt: "Ultritouch4 RCP image",
      },
      popContent:
        " The panel is a shallow 4RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™",
    },
  },
  {
    item: "ULTRITOUCH-PS",
    desc: "Redundant power supply for Ultritouch RCP",
    qty: 0,
    max: 50,
  },
  {
    item: "RCP-ME",
    desc: "Ethernet Enabled 40 Button and LCD Display Control Panel",
    qty: 0,
    max: 50,
    pop: {
      popTitle: "RCP-ME",
      popImg: {
        src: "../assets/images/RCP-ME_tiny.jpg",
        alt: "RCP-ME image",
      },
      popContent:
        "The RCP-ME is a 1RU rack-mountable router control panel offering 40 customisable keys with a 16x2 status display.",
    },
  },
  {
    item: "RCP-QE18",
    desc: "Ethernet Enabled 18 LCD + 8 Fixed Buttons Control Panel",
    qty: 0,
    max: 50,
    pop: {
      popTitle: "RCP-QE18",
      popImg: {
        src: "../assets/images/RCP-QE18_tiny.jpg",
        alt: "RCP-QE18 image",
      },
      popContent:
        "The QE18 is a 1RU rack-mountable router control panael offering 18 dynamic LCD keys + 8 customisable fixed keys.",
    },
  },
  {
    item: "RCP-QE36",
    desc: "Ethernet Enabled 36 LCD + 8 Fixed Buttons Control Panel",
    qty: 0,
    max: 50,
    pop: {
      popTitle: "RCP-QE36",
      popImg: {
        src: "../assets/images/RCP-QE36_tiny.jpg",
        alt: "RCP-QE36 image",
      },
      popContent:
        " The QE36 is a 1RU rack-mountable router control panael offering 36 dynamic LCD keys + 8 customisable fixed keys.",
    },
  },
  {
    item: "ULTRICORE-NVISION",
    desc: "Ultricore NVision protocol License ",
    qty: 0,
    max: 1,
    pop: {
      popContent:
        "The NVISION license allows connectivity to third-party systems using the NVision protocols NP-010 and NP-016.",
    },
  },

  {
    item: "ULTRICORE-SNMP",
    desc: "Ultricore SNMP License",
    qty: 0,
    max: 1,
    pop: {
      popContent:
        "The SNMP license allows trapping of frame alarms by SNMP manager software.",
    },
  },
  {
    item: "ULTRICORE-EMBER+",
    desc: "Ultricore Ember+ protocol License",
    qty: 0,
    max: 1,
    pop: {
      popContent:
        "The EMBER+ license allows logical or physical control of an Ultrix frame.",
    },
  },
  {
    item: "ULTRICORE-PRO",
    desc: "License to provide full Ultricore Profile support on Ultrix frames",
    qty: 0,
    max: 1,
    pop: {
      popContent:
        "Software license that enables support of customizable user profile creation and rights configurations for Ultricore control system. The Ultricore-PRO is included with Ultricore-BCS as standard.",
    },
  },
  {
    item: "ULTRICORE-CC",
    desc: "Ultricore Central Controller",
    qty: 0,
    subtext:
      "Optional - Only recommended for systems with legacy NK Tbus interfaces.",
    pop: {
      popContent:
        "Optional 1RU central controller for Ultrix and legacy NK systems. Provides redundant ethernet ports, 2 Tbus ports, and 2 Serial ports for communication and legacy control",
    },
  },

  {
    item: "ULTRICORE-PS",
    desc: "Redundant Ultricore Power Supply",
    qty: 0,
  },
]);

export const installParts = [
  // { item: "ULTRIX-SHIP_KIT", desc: "Ultrix Ship Kit Assembly", qty: 0 },
  {
    item: "ULTRIX-SI_KIT",
    desc: "Ultrix SI KIT",
    qty: 0,
    max: 10,
  },
  {
    item: "ULTRIX-CONV_CABLE_6",
    desc: "HD-BNC Plug to BNC Jack adapter cable - 1855A 6in.",
    qty: 0,
    max: 100,
  },
  {
    item: "ULTRIX-CONV_CABLE_12",
    desc: "HD-BNC Plug to BNC Jack adapter cable - 1855A 12in.",
    qty: 0,
    max: 100,
  },
  {
    item: "ULTRIX-CONV_CABLE_36",
    desc: "HD-BNC Plug to BNC Plug adapter cable - 1855 36in.",
    qty: 0,
    max: 100,
  },

  {
    item: "ULTRIX-TERM_KIT1694A",
    desc: "1694A SDI Cable Termination kit (qty40)",
    qty: 0,
    max: 100,
  },
  {
    item: "ULTRIX-TERM_KIT1695A",
    desc: "1695A SDI Cable Termination kit (qty40)",
    qty: 0,
    max: 100,
  },
  {
    item: "ULTRIX-TERM_KIT1855A",
    desc: "1855A SDI Cable Termination kit (qty40)",
    qty: 0,
    max: 100,
  },
];

export const switcherParts = Object.freeze({
  acuity: {
    panels: [
      {
        item: "A4-PANEL",
        desc: "Acuity 4 Control Panel",
        qty: 0,
        options: ["A4P-REDPSU-560"],
        pop: {
          popTitle: "Acuity 4",
          popImg: {
            src: "../assets/images/acuity_4-300w.png",
            alt: "Acuity 4",
          },
          popContent:
            "<ul><li>40x Crosspoint Buttons with Mnemonics</li><li>4x Mix Effects Control Rows (Stripes)</li><li> 3x Crosspoint Selection Rows per Stripe</li><li>40x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A4DD-PANEL",
        desc: "Acuity 4 Double Down Control Panel",
        qty: 0,
        options: ["A4P-REDPSU-560"],
        pop: {
          popTitle: "Acuity 4DD",
          popImg: {
            src: "../assets/images/acuity_4-300w.png",
            alt: "Acuity 4DD",
          },
          popContent:
            "<ul><li>38x Crosspoint Buttons with Mnemonics</li><li>4x Mix Effects Control Rows (Stripes)</li><li>4x Crosspoint Selection Rows per Stripe</li><li>37x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A3-PANEL",
        desc: "Acuity 3 Control Panel",
        qty: 0,
        options: ["A3P-REDPSU-560"],
        pop: {
          popTitle: "Acuity 3",
          popImg: {
            src: "../assets/images/acuity_3-300w.png",
            alt: "Acuity 3",
          },
          popContent:
            "<ul><li>32x Crosspoint Buttons with Mnemonics</li><li>3x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>32x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A3DD-PANEL",
        desc: "Acuity 3 Double Down Control Panel",
        qty: 0,
        options: ["A3P-REDPSU-560"],
        pop: {
          popTitle: "Acuity 3DD",
          popImg: {
            src: "../assets/images/acuity_3-300w.png",
            alt: "Acuity 3DD",
          },
          popContent:
            "<ul><li>30x Crosspoint Buttons with Mnemonics</li><li>3x Mix Effects Control Rows (Stripes)</li><li>4x Crosspoint Selection Rows per Stripe</li><li>29x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A3M-PANEL",
        desc: "Acuity 3M Control Panel",
        qty: 0,
        options: ["A3MP-REDPSU-560"],
        pop: {
          popTitle: "Acuity 3M",
          popImg: {
            src: "../assets/images/acuity_3m-300w.png",
            alt: "Acuity 3M",
          },
          popContent:
            "<ul><li>24x Crosspoint Buttons with Mnemonics</li><li>3x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>24x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A3MDD-PANEL",
        desc: "Acuity 3M Double Down Control Panel",
        qty: 0,
        options: ["A3MP-REDPSU-560"],
        pop: {
          popTitle: "Acuity 3MDD",
          popImg: {
            src: "../assets/images/acuity_3m-300w.png",
            alt: "Acuity 3MDD",
          },
          popContent:
            "<ul><li>22x Crosspoint Buttons with Mnemonics</li><li>3x Mix Effects Control Rows (Stripes)</li><li>4x Crosspoint Selection Rows per Stripe</li><li>21x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A2X-PANEL",
        desc: "Acuity 2X Control Panel",
        qty: 0,
        options: ["A2XP-REDPSU-280"],
        pop: {
          popTitle: "Acuity 2X",
          popImg: {
            src: "../assets/images/acuity_2x-300w.png",
            alt: "Acuity 2X",
          },
          popContent:
            "<ul><li>32x Crosspoint Buttons with Mnemonics</li><li>2x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>32x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A2XDD-PANEL",
        desc: "Acuity 2X Double Down Control Panel",
        qty: 0,
        options: ["A2XP-REDPSU-280"],
        pop: {
          popTitle: "Acuity 2XDD",
          popImg: {
            src: "../assets/images/acuity_2x-300w.png",
            alt: "Acuity 3MDD",
          },
          popContent:
            "<ul><li>30x Crosspoint Buttons with Mnemonics</li><li>2x Mix Effects Control Rows (Stripes)</li><li>4x Crosspoint Selection Rows per Stripe</li><li>29x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A2M-PANEL",
        desc: "Acuity 2M Control Panel",
        qty: 0,
        options: ["A2MP-REDPSU-280"],
        pop: {
          popTitle: "Acuity 2M",
          popImg: {
            src: "../assets/images/acuity_2m-300w.png",
            alt: "Acuity 2M",
          },
          popContent:
            "<ul><li>24x Crosspoint Buttons with Mnemonics</li><li>2x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>24x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A2MDD-PANEL",
        desc: "Acuity 2M Double Down Control Panel",
        qty: 0,
        options: ["A2MP-REDPSU-280"],
        pop: {
          popTitle: "Acuity 2MDD",
          popImg: {
            src: "../assets/images/acuity_2m-300w.png",
            alt: "Acuity 2MDD",
          },
          popContent:
            "<ul><li>22x Crosspoint Buttons with Mnemonics</li><li>2x Mix Effects Control Rows (Stripes)</li><li>4x Crosspoint Selection Rows per Stripe</li><li>21x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A1S-PANEL",
        desc: "Acuity 1S Control Panel",
        qty: 0,
        options: ["A1SP-REDPSU-280"],
        pop: {
          popTitle: "Acuity 1S",
          popImg: {
            src: "../assets/images/acuity_1s-300w.png",
            alt: "Acuity 1S",
          },
          popContent:
            "<ul><li>24x Crosspoint Buttons with Mnemonics</li><li>1x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>24x Custom Control Macro Buttons</li></ul>",
        },
      },
      {
        item: "A1SDD-PANEL",
        desc: "Acuity 1S Double Down Control Panel",
        qty: 0,
        options: ["A1SP-REDPSU-280"],
        pop: {
          popTitle: "Acuity 1SDD",
          popImg: {
            src: "../assets/images/acuity_1s-300w.png",
            alt: "Acuity 1SDD",
          },
          popContent:
            "<ul><li>22x Crosspoint Buttons with Mnemonics</li><li>1x Mix Effects Control Rows (Stripes)</li><li>4x Crosspoint Selection Rows per Stripe</li><li>21x Custom Control Macro Buttons</li></ul>",
        },
      },
    ],
    aux: [
      {
        item: "AP-AUX2RU24",
        desc: "24 source button Auxiliary Control Panel 2RU with Source Mnemonics.",
        qty: 0,
        pop: { popContent: "Fits A1S, A2M  and A3M panels." },
      },
      {
        item: "AP-AUX2RU32",
        desc: "32 source button Auxiliary Control Panel 2RU with Source Mnemonics.",
        qty: 0,
        pop: { popContent: "Fits A2X and A3 panels" },
      },
      {
        item: "AP-AUX2RU40",
        desc: "40 source button Auxiliary Control Panel 2RU with Source Mnemonics.",
        qty: 0,
        pop: { popContent: "Fits A4 panels" },
      },
      {
        item: "PSU-12V4A-2PIN",
        desc: "A redundant power supply for the Auxiliary Control Panel Panel",
        qty: 0,
      },
      {
        item: "ULTRITOUCH-2-HR",
        desc: "Ethernet Enabled 2RU Hi Res LCD Touchscreen Control Panel",
        qty: 0,
        pop: {
          popTitle: "Ultritouch-2-HR",
          popImg: {
            src: "../assets/images/ultritouch_tiny_02.png",
            alt: "Ultritouch RCP image",
          },
          popContent:
            "The panel is a shallow 2RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™.",
        },
      },
      {
        item: "ULTRITOUCH4",
        desc: "Ethernet Enabled 4RU LCD Touchscreen Control Panel",
        qty: 0,
        pop: {
          popTitle: "Ultritouch 4",
          popImg: {
            src: "../assets/images/ultritouch_tiny_02.png",
            alt: "Ultritouch 4 image",
          },
          popContent:
            "The panel is a shallow 4RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™",
        },
      },
      {
        item: "ULTRITOUCH-PS",
        desc: "Redundant power supply for Ultritouch RCP",
        qty: 0,
      },
      {
        item: "RCP-ME",
        desc: "Ethernet Enabled 40 Button and LCD Display Control Panel",
        qty: 0,
        pop: {
          popTitle: "RCP-ME",
          popImg: {
            src: "../assets/images/RCP-ME_tiny.jpg",
            alt: "RCP-ME image",
          },
          popContent:
            "The RCP-ME is a 1RU rack-mountable router control panel offering 40 customisable keys with a 16x2 status display.",
        },
      },
      {
        item: "RCP-QE18",
        desc: "Ethernet Enabled 18 LCD + 8 Fixed Buttons Control Panel",
        qty: 0,
        pop: {
          popTitle: "RCP-QE18",
          popImg: {
            src: "../assets/images/RCP-QE18_tiny.jpg",
            alt: "RCP-QE18 image",
          },
          popContent:
            "The QE18 is a 1RU rack-mountable router control panael offering 18 dynamic LCD keys + 8 customisable fixed keys.",
        },
      },
      {
        item: "RCP-QE36",
        desc: "Ethernet Enabled 36 LCD + 8 Fixed Buttons Control Panel",
        qty: 0,
        pop: {
          popTitle: "RCP-QE36",
          popImg: {
            src: "../assets/images/RCP-QE36_tiny.jpg",
            alt: "RCP-QE36 image",
          },
          popContent:
            " The QE36 is a 1RU rack-mountable router control panael offering 36 dynamic LCD keys + 8 customisable fixed keys.",
        },
      },
    ],
    psu: [
      {
        item: "A4P-REDPSU-560",
        desc: "Redundant Power 560w (Control Panel only)",
        qty: 0,
      },
      {
        item: "A4P-REDPSU",
        desc: "Redundant Power (Control Panel only)",
        qty: 0,
        obsolete: true,
        substitute: "A4P-REDPSU-560",
      },
      {
        item: "A3P-REDPSU-560",
        desc: "Redundant Power 560w (Control Panel only)",
        qty: 0,
      },
      {
        item: "A3P-REDPSU",
        desc: "Redundant Power (Control Panel only)",
        qty: 0,
        obsolete: true,
        substitute: "A3P-REDPSU-560",
      },
      {
        item: "A3MP-REDPSU-560",
        desc: "Redundant Power 560w (Control Panel only)",
        qty: 0,
      },
      {
        item: "A3MP-REDPSU",
        desc: "Redundant Power (Control Panel only)",
        qty: 0,
        obsolete: true,
        substitute: "A3MP-REDPSU-560",
      },
      {
        item: "A2XP-REDPSU-280",
        desc: "Redundant Power 280w (Control Panel only)",
        qty: 0,
      },
      {
        item: "A2XP-REDPSU",
        desc: "Redundant Power (Control Panel only)",
        qty: 0,
        obsolete: true,
        substitute: "A2XP-REDPSU-280",
      },
      {
        item: "A2MP-REDPSU-280",
        desc: "Redundant Power 280w (Control Panel only)",
        qty: 0,
      },
      {
        item: "A2MP-REDPSU",
        desc: "Redundant Power (Control Panel only)",
        qty: 0,
        obsolete: true,
        substitute: "A2MP-REDPSU-280",
      },
      {
        item: "A1SP-REDPSU-280",
        desc: "Redundant Power 280w (Control Panel only)",
        qty: 0,
      },
      {
        item: "A1SP-REDPSU",
        desc: "Redundant Power (Control Panel only)",
        qty: 0,
        obsolete: true,
        substitute: "A1SP-REDPSU-280",
      },
    ],
  },
  touchdrive: {
    panels: [
      {
        item: "TD4-PANEL",
        desc: "TouchDrive TD4 Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD4",
          popImg: {
            src: "../assets/images/TouchDrive-TD4_300w.jpg",
            alt: "TouchDrive TD4",
          },
          popContent:
            "<ul><li>35x Crosspoint Buttons with Mnemonics</li><li>4x Assignable Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Advanced Effects Memory keypad on each stripe</li></ul><i>*TD-TOUCHSCREEN not included. <br />*Requires at least 2x CUF-PSU or 1x CUF-RACKPWR</i>",
        },
        psu: { std: { "CUF-PSU": 2 } },
      },
      {
        item: "TD3-PANEL",
        desc: "TouchDrive TD3 Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD3",
          popImg: {
            src: "../assets/images/TouchDrive-TD3_300w.jpg",
            alt: "TouchDrive TD3",
          },
          popContent:
            "<ul><li>35x Crosspoint Buttons with Mnemonics</li><li>3x Assignable Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Advanced Effects Memory keypad on each stripe</li></ul><i>*TD-TOUCHSCREEN not included. <br />*Requires at least 2x CUF-PSU or 1x CUF-RACKPWR</i>",
        },
        psu: { std: { "CUF-PSU": 2 } },
      },
      {
        item: "TD3S-PANEL",
        desc: "TouchDrive TD3S Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD3S",
          popImg: {
            src: "../assets/images/TouchDrive-TD3S_300w.jpg",
            alt: "TouchDrive TD3S",
          },
          popContent:
            "<ul><li>25x Crosspoint Buttons with Mnemonics</li><li>3x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Advanced Effects Memory keypad on each stripe</li></ul><i>*TD-TOUCHSCREEN not included</i>",
        },
      },
      {
        item: "TD2S-PANEL",
        desc: "TouchDrive TD2S Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD2S",
          popImg: {
            src: "../assets/images/TouchDrive-TD2S_300w.jpg",
            alt: "TouchDrive TD2S",
          },
          popContent:
            "<ul><li>25x Crosspoint Buttons with Mnemonics</li><li>2x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Advanced Effects Memory keypad on each stripe</li></ul><i>*TD-TOUCHSCREEN not included</i>",
        },
      },
      {
        item: "TD2-PANEL",
        desc: "TouchDrive TD2 Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD2",
          popImg: {
            src: "../assets/images/TouchDrive-TD2_300w.jpg",
            alt: "TouchDrive TD2",
          },
          popContent:
            "<ul><li>15x Crosspoint Buttons with Mnemonics</li><li>2x Mix Effects Control Rows (Stripes)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Live Assist Global Memory System</li></ul><i>*TD-TOUCHSCREEN not included</i>",
        },
      },
      {
        item: "TD1-PANEL",
        desc: "TouchDrive TD1 Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD1",
          popImg: {
            src: "../assets/images/TouchDrive-TD1_300w.jpg",
            alt: "TouchDrive TD1",
          },
          popContent:
            "<ul><li>15x Crosspoint Buttons with Mnemonics</li><li>1x Mix Effects Control Row (Stripe)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Live Assist Global Memory System</li></ul><i>*TD-TOUCHSCREEN not included</i>",
        },
      },
      {
        item: "TD1C-PANEL",
        desc: "TouchDrive TD1C Control Panel",
        qty: 0,
        pop: {
          popTitle: "TouchDrive TD1C",
          popImg: {
            src: "../assets/images/TouchDrive-TD1C_200h.jpg",
            alt: "TouchDrive TD1C",
          },
          popContent:
            "<ul><li>15x Crosspoint Buttons with Mnemonics</li><li>1x Mix Effects Control Row (Stripe)</li><li>3x Crosspoint Selection Rows per Stripe</li><li>Live Assist Global Memory System</li></ul><i>*TD-TOUCHSCREEN not included</i>",
        },
      },

      {
        item: "TD-TOUCHSCREEN",
        desc: "TouchDrive 15.6-inch touchscreen display",
        qty: 0,
      },
    ],
    aux: [
      {
        item: "ULTRITOUCH-2-HR",
        desc: "Ethernet Enabled 2RU Hi Res LCD Touchscreen Control Panel",
        qty: 0,
        pop: {
          popTitle: "Ultritouch-2-HR",
          popImg: {
            src: "../assets/images/ultritouch_tiny_02.png",
            alt: "Ultritouch RCP image",
          },
          popContent:
            "The panel is a shallow 2RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™.",
        },
      },
      {
        item: "ULTRITOUCH4",
        desc: "Ethernet Enabled 4RU LCD Touchscreen Control Panel",
        qty: 0,
        pop: {
          popTitle: "Ultritouch 4",
          popImg: {
            src: "../assets/images/ultritouch_tiny_02.png",
            alt: "Ultritouch4 image",
          },
          popContent:
            "The panel is a shallow 4RU rack-mountable touchscreen powered by SmartTouch™, which blends intuitive smartphone-like functionality with the customization power of DashBoard’s PanelBuilder™",
        },
      },
      {
        item: "ULTRITOUCH-PS",
        desc: "Redundant power supply for Ultritouch RCP",
        qty: 0,
      },
      {
        item: "RCP-ME",
        desc: "Ethernet Enabled 40 Button and LCD Display Control Panel",
        qty: 0,
        pop: {
          popTitle: "RCP-ME",
          popImg: {
            src: "../assets/images/RCP-ME_tiny.jpg",
            alt: "RCP-ME image",
          },
          popContent:
            "The RCP-ME is a 1RU rack-mountable router control panel offering 40 customisable keys with a 16x2 status display.",
        },
      },
      {
        item: "RCP-QE18",
        desc: "Ethernet Enabled 18 LCD + 8 Fixed Buttons Control Panel",
        qty: 0,
        pop: {
          popTitle: "RCP-QE18",
          popImg: {
            src: "../assets/images/RCP-QE18_tiny.jpg",
            alt: "RCP-QE18 image",
          },
          popContent:
            "The QE18 is a 1RU rack-mountable router control panael offering 18 dynamic LCD keys + 8 customisable fixed keys.",
        },
      },
      {
        item: "RCP-QE36",
        desc: "Ethernet Enabled 36 LCD + 8 Fixed Buttons Control Panel",
        qty: 0,
        pop: {
          popTitle: "RCP-QE36",
          popImg: {
            src: "../assets/images/RCP-QE36_tiny.jpg",
            alt: "RCP-QE36 image",
          },
          popContent:
            " The QE36 is a 1RU rack-mountable router control panael offering 36 dynamic LCD keys + 8 customisable fixed keys.",
        },
      },
    ],
    psu: [
      {
        item: "CUF-PSU",
        desc: "Carbonite Ultra Standard Power Supply",
        qty: 0,
        pop: {
          popTitle: "Carbonite Ultra Standard Power Supply.",
          popContent:
            " Select 1 (or 2 for power redundancy) for each TouchDrive panel",
        },
      },
      {
        item: "CUF-RACKPWR",
        desc: "ULTRIPOWER for Carbonite Ultra",
        qty: 0,
      },
    ],
  },
});

export const tallySystems = [
  {
    item: "TLY-TSI4000-CP",
    desc: "TSI-4000 Tally System Interface and Tally System Console 3 (incl. 2 NICs and 2 P/S)",
    id: 0,
    qty: 1,
    obsolete: true,
    substitute: "",
    licenses: [
      {
        type: "TLY-Evertz",
        desc: "License for Evertz Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Generic-TSL",
        desc: "License for Generic (TSL) Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Cobalt",
        desc: "License for Cobalt Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-TAG",
        desc: "License for TAG Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Lawo",
        desc: "License for Lawo Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-GVG",
        desc: "License for GVG Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Imagine",
        desc: "License for Imagine Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Apantac",
        desc: "License for Apantac Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Marshall-IMD",
        desc: "License for Marshall IMD Protocol Support",
        qty: 0,
      },
    ],
  },
  {
    item: "TLY-TSI4000-ACO",
    desc: "TSI-4000 Redundancy Pkg (incl. 2-TSI-4000 and 2 P/S and 1-TSI-4000ACO Auto Changeover Unit)",
    id: 0,
    qty: 1,
    obsolete: true,
    substitute: "",
    licenses: [
      {
        type: "TLY-Evertz",
        desc: "License for Evertz Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Generic-TSL",
        desc: "License for Generic (TSL) Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Cobalt",
        desc: "License for Cobalt Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-TAG",
        desc: "License for TAG Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Lawo",
        desc: "License for Lawo Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-GVG",
        desc: "License for GVG Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Imagine",
        desc: "License for Imagine Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Apantac",
        desc: "License for Apantac Multi-Viewer Protocol Support",
        qty: 0,
      },
      {
        type: "TLY-Marshall-IMD",
        desc: "License for Marshall IMD Protocol Support",
        qty: 0,
      },
    ],
  },
  {
    item: "TLY-TXI48",
    desc: "GPI I/O Interface with 48 Jumper Config Inputs and 48 Contact Closure Outputs (incl 2 external P/S)",
    qty: 0,
  },
  {
    item: "TLY-TXP16",
    desc: "Tally Expansion Panel with 16 front panel user configurable I/O. Includes two external P/S.",
    qty: 0,
  },
];

export const services = [
  {
    item: "ULTRIX-ONL-1DAY",
    desc: "Ultrix Online Training - 1 Day",
    longdesc: "",
    qty: 0,
    max: 10,
  },
  {
    item: "ULTRIX-OTR-1DAY",
    desc: "Ultrix Operational Training - 1 Day",
    longdesc: "",
    qty: 0,
    max: 10,
  },
  {
    item: "ULTRIX-OTT-1DAY",
    desc: "Ultrix Technical Training - 1 Day",
    longdesc: "",
    qty: 0,
    max: 10,
  },
  {
    item: "ULTRIX-ONL-COM-1DAY",
    desc: "Ultrix Online Commissioning - 1 Day",
    longdesc: "",
    qty: 0,
    max: 10,
  },
  {
    item: "ULTRIX-COM-1DAY",
    desc: "Ultrix Onsite Commissioning - 1 Day",
    longdesc: "*Does not include flights/accomodation",
    qty: 0,
    max: 10,
  },
  {
    item: "ACUITY-COM-1DAY",
    desc: "Acuity Onsite Commissioning - 1 Day",
    qty: 0,
  },
  {
    item: "ACUITY-ONL-1DAY",
    desc: "Acuity Online Training - 1 Day",
    qty: 0,
  },
  {
    item: "ACUITY-OTT-1DAY",
    desc: "Acuity Onsite Technical Training - 1 Day",
    qty: 0,
  },
  {
    item: "ACUITY-OTR-1DAY",
    desc: "Acuity Onsite Operations Training - 1 Day",
    qty: 0,
  },
  {
    item: "CARBONITE-COM-1DAY",
    desc: "Carbonite Onsite Commissioning - 1 Day",
    qty: 0,
  },
  {
    item: "CARBONITE-ONL-1DAY",
    desc: "Carbonite Online Operational Training - 1 Day",
    qty: 0,
  },
  {
    item: "CARBONITE-OTT-1DAY",
    desc: "Carbonite Onsite Technical Training - 1 Day",
    qty: 0,
  },
  {
    item: "CARBONITE-OTR-1DAY",
    desc: "Carbonite Onsite Operational Training - 1 Day",
    qty: 0,
  },
  {
    item: "TLY-ONL-1DAY",
    desc: "Tally Systems Online Training - 1 Day",
    qty: 0,
  },
  {
    item: "TLY-OTR-1DAY",
    desc: "Tally Systems Onsite Operational Training - 1 Day",
    qty: 0,
  },
  {
    item: "TLY-COM-1DAY",
    desc: "Tally Systems Onsite Commissioning - 1 Day",
    qty: 0,
  },
  {
    item: "TLY-ONL-COM-1DAY",
    desc: "Tally Systems Online Commissioning - 1 Day",
    qty: 0,
  },
];
